var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5872 7.99041C11.0399 7.10365 13.032 4.44338 15.5672 4.44338C18.1025 4.44338 19.0382 6.80807 19.1891 7.99041C19.7927 8.43379 21 9.58658 21 10.6507C21 11.7148 20.3964 12.572 20.0945 12.8676C20.0945 13.311 20.004 14.3751 19.6418 15.0845C19.2796 15.7939 17.9818 16.5624 17.3782 16.858C17.3782 16.858 17.9818 20.405 17.8309 19.9616C17.68 19.5183 16.9149 18.6247 15.5672 17.7448C14.209 16.858 13.3811 15.8843 13.0793 15.8843M8.59266 15.1956C8.13993 15.7868 6.87473 16.9468 4.70162 15.528C2.52852 14.1092 2.8907 12.2765 3.34343 11.5376C3.19255 10.7986 3.07189 9.14334 3.79626 8.43393C4.52062 7.72452 5.00354 7.54717 5.15445 7.54717C5.30536 6.956 5.78827 5.68498 6.51264 5.33028C7.23701 4.97557 8.32356 5.18248 8.77629 5.33028C9.22902 4.88685 10.4061 4 11.4927 4C12.5792 4 13.2706 4.61499 13.4215 4.91058M8.32354 12.8676C8.17263 14.0499 8.41408 16.5033 10.5872 16.858C13.3036 17.3014 13.3036 14.1977 15.5672 14.1977",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/Brain.8dea6986f81c3ab858de3a5ff5fe64f5.svg";
export { ForwardRef as ReactComponent };